import { AMBASSADORS_LP_TYPE, COMPARISON_TYPE, COOKIE_SETTINGS_TYPE, CP_TYPE, DEALER_LOCATOR_TYPE, EVENTS_CLP_TYPE, EXPERIENCES_LP_TYPE, MAINTENANCE_TYPE, NCP_TYPE, NEWS_CLP_TYPE, NEWS_EVENT_TYPE, OFFERS_PROMO_LP_TYPE, OFFERS_PROMO_TYPE, OWNER_MANUALS_TYPE, PARTNERS_LP_TYPE, RETURN_FORM_TYPE, } from '@yme/common/constants';
export const BLOOM_REACH_SCRIPT_LOADED = 'bloom-reach-script-loaded';
export var PixelPageView;
(function (PixelPageView) {
    PixelPageView["PRODUCT_PAGE"] = "product";
    PixelPageView["CATEGORY"] = "category";
    PixelPageView["CONTENT"] = "content";
    PixelPageView["CONVERSION"] = "conversion";
    PixelPageView["HOME"] = "homepage";
    PixelPageView["OTHER"] = "other";
    PixelPageView["SEARCH"] = "search";
})(PixelPageView || (PixelPageView = {}));
export var PixelEvent;
(function (PixelEvent) {
    PixelEvent["ADD_TO_CART"] = "add-to-cart";
    PixelEvent["SEARCH"] = "search";
    PixelEvent["SUGGEST"] = "suggest";
})(PixelEvent || (PixelEvent = {}));
export var PixelEventGrouping;
(function (PixelEventGrouping) {
    PixelEventGrouping["CART"] = "cart";
    PixelEventGrouping["SUGGEST"] = "suggest";
})(PixelEventGrouping || (PixelEventGrouping = {}));
export var PixelEventAction;
(function (PixelEventAction) {
    PixelEventAction["CLICK"] = "click";
    PixelEventAction["CLICK_ADD"] = "click-add";
    PixelEventAction["SUBMIT"] = "submit";
})(PixelEventAction || (PixelEventAction = {}));
export const TRACKED_CONTENT_PAGES = [
    NEWS_EVENT_TYPE,
    OFFERS_PROMO_TYPE,
    CP_TYPE,
    NCP_TYPE,
    COMPARISON_TYPE,
    OWNER_MANUALS_TYPE,
    DEALER_LOCATOR_TYPE,
    RETURN_FORM_TYPE,
    COOKIE_SETTINGS_TYPE,
    MAINTENANCE_TYPE,
];
export const TRACKED_OTHER_PAGES = [
    NEWS_CLP_TYPE,
    EVENTS_CLP_TYPE,
    OFFERS_PROMO_LP_TYPE,
    EXPERIENCES_LP_TYPE,
    PARTNERS_LP_TYPE,
    AMBASSADORS_LP_TYPE,
];
export const YAMAHA_MOTOR = 'yamaha_motor';
export const CONTENT = 'content';
export const BR_ID_COOKIE = '_br_uid_2';
export var FlParams;
(function (FlParams) {
    FlParams["ITEM_ID"] = "item_id";
    FlParams["TITLE"] = "title";
    FlParams["URL"] = "url";
    FlParams["PID"] = "pid";
    FlParams["DESCRIPTION"] = "description";
    FlParams["DATE"] = "date";
    FlParams["DATE_TO"] = "date_to";
    FlParams["PRIMARY_TYPE"] = "primary_type";
    FlParams["THUMB_IMAGE"] = "thumb_image";
    FlParams["PRICE"] = "price";
    FlParams["PRICE_VARIANT"] = "price_variant";
    FlParams["SALE_PRICE"] = "sale_price";
    FlParams["SALE_PRICE_VARIANT"] = "sale_price_variant";
    FlParams["FROM_PRICE"] = "from_price";
    FlParams["DRIVER_LICENCE"] = "driver_licence";
    FlParams["IS_DISCOUNTED"] = "is_discounted";
    FlParams["IS_ELECTRIC"] = "is_electric";
    FlParams["CURRENCY_CODE"] = "currency_code";
    FlParams["PRODUCT_YEAR"] = "product_year";
    FlParams["IS_LATEST_MODEL"] = "is_latest_model";
    FlParams["PRICE_TOOLTIP_TEXT"] = "segment_price_extra_information_tooltip_text";
    FlParams["EMBARGO_EXTERNAL_DATE"] = "embargo_external_date";
    FlParams["SKU"] = "sku";
    FlParams["IS_YMT"] = "is_ymt";
    FlParams["IS_NEW"] = "is_new";
    FlParams["COLOR"] = "sku_color";
    FlParams["TYPE_EN"] = "type_en";
    FlParams["VARIANT_ID"] = "skuid";
    FlParams["SIZE"] = "sku_size";
    FlParams["ANALYTICS_CATEGORIES"] = "analytics_categories";
})(FlParams || (FlParams = {}));
export const BLOOMREACH_ANALYTICS_DISCOUNTED_KEY = 'isDiscounted';
export const BLOOMREACH_ANALYTIC_KEYS_LIST = {
    is_discounted: 'is_discounted',
    type: 'type',
    gender: 'gender',
    collection: 'collection',
    sizes: 'sizes',
    colors: 'colors',
    accessory_usage: 'accessory_usage',
    subcategories: 'subcategories',
    search: 'search',
    sort: 'sort',
};
export const BLOOMREACH_QUERY_ANALYTIC_KEYS_LIST = {
    [BLOOMREACH_ANALYTIC_KEYS_LIST.is_discounted]: 'discounted',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.search]: 'search',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.sort]: 'sort',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.type]: 'accessoryType',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.gender]: 'gender',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.collection]: 'collection',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.sizes]: 'size',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.colors]: 'colourName',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.accessory_usage]: 'accessoryUsage',
    [BLOOMREACH_ANALYTIC_KEYS_LIST.subcategories]: 'id',
};
export var RequestType;
(function (RequestType) {
    RequestType["SEARCH"] = "search";
    RequestType["SUGGEST"] = "suggest";
})(RequestType || (RequestType = {}));
export var SearchType;
(function (SearchType) {
    SearchType["KEYWORD"] = "keyword";
    SearchType["CATEGORY"] = "category";
})(SearchType || (SearchType = {}));
export var FacetFields;
(function (FacetFields) {
    FacetFields["PRIMARY_TYPE"] = "primary_type";
    FacetFields["UNIT_TYPE"] = "unit_type";
    FacetFields["SUBCATEGORIES"] = "subcategories";
    FacetFields["COLLECTION"] = "collection";
    FacetFields["GENDER"] = "gender";
    FacetFields["TYPE"] = "type";
    FacetFields["SIZES"] = "sizes";
    FacetFields["COLORS"] = "colors";
    FacetFields["IS_DISCOUNTED"] = "is_discounted";
    FacetFields["ACCESSORY_USAGE"] = "accessory_usage";
    FacetFields["CATEGORY"] = "category";
    FacetFields["TYPE_EN"] = "type_en";
    FacetFields["COMPATIBLE_PRODUCTS"] = "compatible_products";
})(FacetFields || (FacetFields = {}));
export var SearchParams;
(function (SearchParams) {
    SearchParams["QUERY"] = "q";
    SearchParams["CATEGORY"] = "category";
    SearchParams["SORT"] = "sort";
})(SearchParams || (SearchParams = {}));
export var SearchCategoryTypes;
(function (SearchCategoryTypes) {
    SearchCategoryTypes["UNIT"] = "unit";
    SearchCategoryTypes["ACCESSORY"] = "accessory";
    SearchCategoryTypes["APPAREL"] = "apparel";
    SearchCategoryTypes["NEWS"] = "news";
    SearchCategoryTypes["EVENTS"] = "event";
    SearchCategoryTypes["DESTINATIONS"] = "destinations";
    SearchCategoryTypes["OTHER"] = "other";
})(SearchCategoryTypes || (SearchCategoryTypes = {}));
export const SEARCH_CATEGORY_PRIORITY = {
    [SearchCategoryTypes.UNIT]: 1,
    [SearchCategoryTypes.ACCESSORY]: 2,
    [SearchCategoryTypes.APPAREL]: 3,
    [SearchCategoryTypes.NEWS]: 4,
    [SearchCategoryTypes.EVENTS]: 5,
    [SearchCategoryTypes.DESTINATIONS]: 6,
    [SearchCategoryTypes.OTHER]: 7,
};
export const SEARCH_STRING_KEY = '{searchString}';
export const CONTENT_SEARCH_CATEGORIES = [
    SearchCategoryTypes.NEWS,
    SearchCategoryTypes.EVENTS,
    SearchCategoryTypes.DESTINATIONS,
    SearchCategoryTypes.OTHER,
];
export const PRODUCT_SEARCH_CATEGORIES = [
    SearchCategoryTypes.UNIT,
    SearchCategoryTypes.ACCESSORY,
    SearchCategoryTypes.APPAREL,
];
export const NO_IMAGE = 'no_image';
export const ACCESSORY_FACETS = [
    FacetFields.IS_DISCOUNTED,
    FacetFields.SUBCATEGORIES,
    FacetFields.COLLECTION,
    FacetFields.GENDER,
    FacetFields.TYPE,
];
export const APPAREL_FACETS = [
    FacetFields.IS_DISCOUNTED,
    FacetFields.SUBCATEGORIES,
    FacetFields.GENDER,
    FacetFields.COLLECTION,
    FacetFields.TYPE,
    FacetFields.SIZES,
    FacetFields.COLORS,
];
export const ACCESSORY_FACETS_PLP = [
    FacetFields.SUBCATEGORIES,
    FacetFields.COLLECTION,
    FacetFields.GENDER,
    FacetFields.TYPE,
];
export const APPAREL_FACETS_PLP = [
    FacetFields.SUBCATEGORIES,
    FacetFields.GENDER,
    FacetFields.COLLECTION,
    FacetFields.TYPE,
    FacetFields.SIZES,
    FacetFields.COLORS,
];
export const DID_YOU_MEAN_STRING_KEY = '{didYouMeanString}';
export const AUTHOR_LINK_PREFIX = '/content/yme';
export const PDP_TEMPLATE_NAME = 'pdp';
